import { stringToDashAndLowerCase } from '@scp/ui-shared/core/utils';
var componentUtilsConfig = {
  applyE2EAttributes: false
};
export function applyE2EAttributes(flag) {
  componentUtilsConfig.applyE2EAttributes = flag;
}
export var getE2eLabel = function getE2eLabel(componentTitle) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var customLabel = arguments.length > 2 ? arguments[2] : undefined;

  if (!componentUtilsConfig.applyE2EAttributes && process.env.REACT_APP_APPLY_E2E_ATTRIBUTES !== 'true') {
    return;
  }

  if (customLabel) {
    return "".concat(stringToDashAndLowerCase(customLabel)).concat(suffix);
  }

  if (!!componentTitle && typeof componentTitle === 'string') {
    return "".concat(stringToDashAndLowerCase(componentTitle)).concat(suffix);
  }
};